import { MODEL_KEY } from '../../../model'

const MESSAGE_KEY = {
  ...MODEL_KEY,

  VALUE: 'value',
  STATUS: 'status',
  TYPE: 'type',

  // Derived
  READ_AT: 'readAt',

  // Associations
  REPLIES: 'replies',
  PROFILE: 'profile',
  ATTACHMENTS: 'attachments',

  // Foreign
  PROFILE_ID: 'profileId',
  MESSAGE_ID: 'message_id',
  CHAT_ID: 'chatId'

}

const MESSAGE_PRIVATE_KEYS = []
export const MESSAGE_ASSOCIATIONS = [
  MESSAGE_KEY.PROFILE,
  MESSAGE_KEY.ATTACHMENTS,
  MESSAGE_KEY.REPLIES
]

export { MESSAGE_PRIVATE_KEYS }

export { MESSAGE_KEY }

const MESSAGE_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: MESSAGE_PRIVATE_KEYS
    }
  }

}

export { MESSAGE_SCOPE }
const MESSAGE_AUDIT = {
  CREATED: 'Message Created',
  UPDATED: 'Message Updated',
  DELETED: 'Message Deleted'
}

export { MESSAGE_AUDIT }
export const MESSAGE_CLASS_NAME = 'Message'

const MESSAGE_STATUS = {

  // General
  OPEN: 1,
  IN_PROGRESS: 2,
  CLOSED: 3

}

export { MESSAGE_STATUS }
